import React from "react";

const CrossIcon = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width={size}
    height={size}
    viewBox="0 0 450 450"
    enableBackground="new 0 0 450 450"
    xmlSpace="preserve"
  >
    <script
      xmlns=""
      data-timezone-ext-el='["Etc/GMT",0,0,null]'
      src="chrome-extension://cejckpjfigehbeecbbfhangbknpidcnh/data/inject-content.js"
    />
    <circle fill="#CC2200" cx="225" cy="225" r="225" />
    <g>
      <line
        fill="#FFFFFF"
        stroke="#FFFFFF"
        strokeWidth="70"
        x1="106.742"
        y1="110.083"
        x2="343.258"
        y2="346.599"
      />
      <line
        fill="#FFFFFF"
        stroke="#FFFFFF"
        strokeWidth="70"
        x1="106.742"
        y1="346.599"
        x2="343.258"
        y2="110.084"
      />
    </g>
  </svg>
);

export default CrossIcon;
